<template>
  <div class="core">
    <div class="layui-layer-content">
      <div class="layui-layer-wrap">
        <div class="form-collapse">
          <div class="info">
            <layui-form ref="allForm" :rule="form_rulesp" :after-save="handleAfterSave" :showForm="true">
              <div class="layui-form">
                <pub-collapse :title="formData.WORK_ORDER_CATEGORY === '1' ? '服务请求运维单信息' : '服务请求工程单信息'">
                  <template #content>
                    <layui-collapse>
                      <workOrder ref='workOrder' :editRow="formData"></workOrder>
                      <returnVisit ref='returnVisit' :editRow="formData" :enabled="formData.ORDER_STATE == '4' && orderType != 'ck'"></returnVisit>
                    </layui-collapse>
                  </template>
                </pub-collapse>

                <pub-collapse
                  :showHide="index == 0 ? true : false"
                  :title="(formData.WORK_ORDER_CATEGORY === '1' ? '现场服务运维单信息' : '现场服务工程单信息') +item.SERVICE_ORDER_NUM"
                  v-for="(item, index) in formData['YW_SERVICE_ORDER_V1']" :key="index">
                  <template #content>
                    <layui-collapse>
                      <serviceOrder ref='serviceOrder' :editRow="item"></serviceOrder>
                      <signinout ref='signinout' :editRow="item"></signinout>
                      <selfCheck ref='selfCheck' :editRow="item"></selfCheck>
                      <acceptance ref='acceptance' :editRow="item"></acceptance>
                      <backorder ref='backorder' :editRow="item"></backorder>
                      <appraise ref='appraise' :editRow="item"></appraise>
                      <dispute ref='dispute' :editRow="item"></dispute>
                    </layui-collapse>
                  </template>
                </pub-collapse>
              </div>
              <div class="layui-form-btn">
                <div class="layui-footer">
                  <button class="layui-btn refresh" title="关闭" @click="handleBtnclick('close')">关 闭</button>
                  <button class="layui-btn" title="派单" @click="dispatch()" v-if="orderType == 'ck' && formData.WORK_ORDER_METHOD.indexOf('1') > -1 && this.security.hasAuth('serviceOrder_dispatch')">派 单</button>
                  <button class="layui-btn" title="保存" @click="handleBtnclick('save')" v-if="orderType != 'ck'">保 存</button>
                </div>
              </div>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import workOrder from '../detailForm/workOrderForm'
import returnVisit from '../detailForm/returnVisitForm'
import serviceOrder from '../detailForm/serviceOrderForm'
import signinout from '../detailForm/signInOutForm'
import selfCheck from '../detailForm/selfCheckForm'
import acceptance from '../detailForm/acceptanceForm'
import backorder from '../detailForm/backOrderForm'
import appraise from '../detailForm/appraiseForm'
import dispute from '../detailForm/disputeForm'

/**
 * 服务请求单-查看
 */
export default {
  components: {
    workOrder,
    returnVisit,
    serviceOrder,
    signinout,
    selfCheck,
    acceptance,
    backorder,
    appraise,
    dispute
  },
  props: {
  },
  data () {
    return {
      form_rulesp: {
      },
      formData: {},
      orderType: '',
      scrollTop:0
    }
  },
  activated(){
    if(this.scrollTop) {
      $(".core").animate({scrollTop: this.scrollTop}, 0)
    }
    //如果二级菜单不展示，底部样式修改
    if(!$('.layui-side-scroll').is(":visible")){
        $(".layui-footer").css("left","0");
    } else {
        $(".layui-footer").removeAttr("style");
    }
  },
  mounted () {
    if(this.tabParam) {
      this.formData = this.tabParam.formData;
      this.orderType = this.tabParam.orderType;
      this.tableObj = this.tabParam.tableObj;
    }
    this.$nextTick(()=> {
      if(this.orderType === 'hf'){
        var anchor = this.$refs.returnVisit.$el.offsetTop;
        $(".core").animate({
          scrollTop: anchor
        },500);
      }
    })
    var that = this;
    $(".core").scroll(function(event){
      that.scrollTop = $(".core").scrollTop();
    })
  },
  methods: {
    /**
     * 保存、关闭
     */
    handleBtnclick(type) {
      switch (type) {
        case 'close': {
          this.baseComponent.closeComponent(this.tabParam.cloneMenu);
          this.baseComponent.loadComponentByName('serviceRequest');
          break
        }
        case 'save': {
          this.$refs.allForm.editRow = $.extend(true, {}, this.$refs.returnVisit.editRow);
          if(this.orderType === 'hf'){
            this.$refs.allForm.editRow._SLAVE['YW_RETURN_VISIT'] = [];
            var saveEditRow = $.extend(true, {}, this.$refs.returnVisit.editRow);
            saveEditRow.IS_NEW = true;
            this.$refs.allForm.editRow._SLAVE['YW_RETURN_VISIT'].push(saveEditRow);
            this.$refs.allForm.editRow.ORDER_STATE = '5';//5.对账付款
          } else if(this.orderType === 'dz'){
            //判断收入费用状态为2：已付款   支出费用状态为3：已付款
            if(this.$refs.allForm.editRow.INCOME_AMOUNT_TYPE == '2' && this.$refs.allForm.editRow.EXPENSES_AMOUNT_TYPE == '3'){
              this.$refs.allForm.editRow.ORDER_STATE = '6';//6.已关闭
            }
            this.$refs.allForm.requestUniqueId = "editWorkOrder";
          }
          this.$refs.allForm.callableSave("YW_WORK_ORDER");
          break
        }
        default: {
          break
        }
      }
    },
    handleAfterSave() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu)
      this.baseComponent.loadComponentByName('serviceRequest')
      if (this.tableObj) {
        this.tableObj.pageInfo.pageIndex = 1
        this.tableObj.load()
      }
    },
    //派单
    dispatch(){
      var data = {};
      Object.assign(data,this.formData);
      data.F_WORK_ORDER_ID = data.WORK_ORDER_ID;
      data.DISPATCH = "true";//派单
      data.IS_NEW = true;
      if(data.WORK_ORDER_CATEGORY == '1') {
        this.baseComponent.smartLoadComponent('siteRequestForm', {serviceRequest: this, tableObj: this.tableObj, editRow: data, type: 'yw', title: '创建现场服务运维单', from: 'dispatchForm'})
      } else {
        this.baseComponent.smartLoadComponent('siteRequestForm', {serviceRequest: this, tableObj: this.tableObj, editRow: data, type: 'gc', title: '创建现场服务工程单', from: 'dispatchForm'})
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/workOrder/serviceRequest/serviceRequestForm.vue